/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/edit";

import ManagePromotion from "./manage-promotion";
import AddPromotion from "./manage-promotion/addPromotion";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSystemSettings from "./manageSystemSettings";
import AddEmailTemplate from "./manageSystemSettings/addEmailTemplate";

import ManageQrCode from "./manageQrCode";
import ManageRewards from "./manageRewards";
import AddRewards from "./manageRewards/add";
import RewardsDetail from "./manageRewards/view";
import ViewPromotion from "./manage-promotion/viewPromotion";
import ManageTransction from "./manage-transction";
import ViewTransction from "./manage-transction/viewTransction";
import ManageActivityLogs from "./manageActivityLogs";
import ManageFeedbackReports from "./manageFeedbackReports";
import ViewProduct from "../features/productManagement/viewProduct";
import Signup from "./auth/signup";
import SignupForm from "./auth/signup-form";
import Revenue from "../features/manage-revenue";
import Finances from "./finances";
import StoreBranding from "./store-branding";
import AdminSupport from "./admin-support";
import SubscriptionForm from "./auth/subscriptionDetails";
import StoreInformation from "./store-information";
import StoreManagement from "./manage-stores";
import AddStoreInfo from "./manage-stores/add-store";
import MyOrders from "./purchase-services/my-orders";
import MyWhistlist from "./purchase-services/my-whistlist";
import PurchaseProduct from "./purchase-services/purchase-service";
import PurchaseServices from "./purchase-services/purchase-service";
import ViewService from "./purchase-services/purchase-service/view";
import Blogs from "./blogs";
import AddBlog from "./blogs/add";
import AiInsights from "./ai-insights";
import ViewAiInsights from "./ai-insights/view";
import QuesAns from "./ques-ans";
import TradeLicence from "./trade-license";
import FAQs from "./faq";
import TermsConditions from "./terms-conditions";
import PrivacyPolicy from "./privacy-policy";
import ViewQuesAns from "./ques-ans/view";
import Referral from "./referral";
import AddReferral from "./referral/add";
import ComplianceStatus from "./compliance-status";
import MySubscription from "./my-subscription";
import ViewAdminSupport from "./admin-support/view";
import TransctionLog from "./transction-history/transctionLog";
import ViewTradeLicence from "./trade-license/view";
import ViewWork from "./purchase-services/purchase-service/viewWork";
import AITokenUtilization from "./ai-token/page";
import KnowledgeBase from "./admin-support/knowledgeBase";
import VideoTutorials from "./admin-support/videoTutorials";
import ViewBlogs from "./blogs/view";
import PaymentPreferences from "./payment-preferences";
import ViewPurchaseServices from "./purchase-services/my-orders/view";

export default {
  Login,
  Signup,
  SignupForm,
  SubscriptionForm,
  ForgotPassword,
  StoreManagement,
  StoreInformation,
  OtpVerification, AddStoreInfo,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ViewProduct,
  ManageNotifications,
  AddNotification,
  ViewWork,
  TransctionLog,
  NotificationDetail,
  ViewTradeLicence,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSystemSettings,
  AdminSupport,
  Finances,
  ManagePromotion,
  AddPromotion,
  AddEmailTemplate,
ViewService,
  ManageQrCode,
  ManageRewards,
  AddRewards,
  RewardsDetail,
  ViewPromotion,
  AITokenUtilization,
  ManageTransction,
  ViewTransction,
  ManageActivityLogs,
  ManageFeedbackReports,
  Referral,
  AddReferral,
  Revenue,
  MyOrders,
  MyWhistlist,
  PurchaseServices,
  StoreBranding,
  Blogs,
  KnowledgeBase,
  ViewPurchaseServices,
  ViewBlogs,
  ViewAdminSupport,
  VideoTutorials,
  AddBlog,
  PaymentPreferences,
  ComplianceStatus,
  MySubscription,
  AiInsights,
  QuesAns,
  TradeLicence,
  FAQs,
  TermsConditions,
  ViewQuesAns,
  PrivacyPolicy,
  ViewAiInsights
};
